import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth
  const [error, setError] = useState("");

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const login = async (identifier, password, remember_me) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { identifier, password, remember_me });
      if (data.token) localStorage.setItem("abs_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const msg = formatApiError(e);
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const demoLogin = async (role) => {
    setError("");
    try {
      const { data } = await api.post("/auth/demo-login", { role });
      if (data.token) localStorage.setItem("abs_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const msg = formatApiError(e);
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("abs_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, demoLogin, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
